<ng-container *ngIf="hasFavourite">
  <div edsFlexbox justifyContent="center">
    <button class="transparent" (click)="toggle()">
      <eds-icon
        *ngIf="!showRemoveIcon"
        class="fav-icon"
        [type]="active ? 'bookmark-active' : 'bookmark-inactive'"
        edsTooltip
        tooltipType="medium"
        [tooltipPositionDefault]="tooltipPosition"
        tooltipBehavior="absolute"
        [tooltipContent]="tooltipContent"
        (tooltipClickedEmit)="onTooltipClicked($event)"
        (onTooltipCloseEmit)="onTooltipClicked($event)"
      >
      </eds-icon>
      <eds-icon
        *ngIf="showRemoveIcon"
        type="cross"
        size="small"
        class="fav-icon"
        edsTooltip
        tooltipType="medium"
        [tooltipPositionDefault]="tooltipPosition"
        [setDefaultPositionRight]="true"
        tooltipBehavior="fixed"
        [tooltipContent]="tooltipContent"
        (tooltipClickedEmit)="onTooltipClicked($event)"
        (onTooltipCloseEmit)="onTooltipClicked($event)"
        widthHackOveride="190"
      ></eds-icon>
      <span class="sr-only">
        {{
          active
            ? ("products.remove" | translate) +
              " " +
              fundName +
              " " +
              ("products.from-favorites" | translate)
            : ("products.add" | translate) +
              " " +
              fundName +
              " " +
              ("products.to-favorites" | translate)
        }}
      </span>
    </button>
  </div>
</ng-container>
